// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__scfP8","comment":"styles_comment__1oOue"};